import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';
import { canViewAdminPage } from '../utils/adminPermissions';

// Shows an admin page only when the role can view it (the backend checks again)
export default function RequirePermission({ children }) {
    const { can, permissions } = useAuth();
    const { isDarkMode } = useTheme();
    const { pathname } = useLocation();

    if (!permissions) {
        return (
            <div className="flex items-center justify-center min-h-[200px]">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-500"></div>
            </div>
        );
    }

    if (!canViewAdminPage(can, pathname)) {
        return (
            <div className={`p-6 ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                <h1 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>No access</h1>
                <p>Your role doesn't have permission to view this page.</p>
            </div>
        );
    }

    return children;
}
